import { createApi } from '@reduxjs/toolkit/query/react';
import { baseTasksQuery } from './config';
import { GetNotificationResponse, UpdateNotificationRequest } from 'src/types';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseTasksQuery,
  endpoints: (build) => ({
    getLastSeenNotificationId: build.query<
      GetNotificationResponse,
      { user_id: string }
    >({
      query: ({ user_id }) =>
        `/users/${user_id}/notifications/product_announcements`,
    }),

    updateNotificationLastSeenById: build.mutation<
      void,
      UpdateNotificationRequest & {
        user_id: string;
      }
    >({
      query: ({ user_id, last_seen_id }) => ({
        url: `users/${user_id}/notifications/product_announcements`,
        method: 'PUT',
        body: { last_seen_id },
      }),
    }),
  }),
});

export const {
  useGetLastSeenNotificationIdQuery,
  useLazyGetLastSeenNotificationIdQuery,
  useUpdateNotificationLastSeenByIdMutation,
} = notificationsApi;
